export default {
    namespaced: true,

    state: () => {
        return {
            showCancelModal: false,
            previous: {},

            data: {
                env: null,
                groupId: null,
                properties: {},
                dynamicProviderKey: null,
                nextProviderKeyAfterExistingAccount: null,
                webSessionId: null,
                warnCountdownMillis: null,
                timeoutAfterMillis: null,
                extensions: [],
            },
        }
    },

    mutations: {
        showCancelModal(state, flag) {
            state.showCancelModal = flag
        },

        update(state, session) {
            state.data = session
            state.data.showCancelModal = false
        },

        updateEnv(state, env) {
            state.data = { ...state.data, env }
        },

        updatePrevious(state, session) {
            state.previous = session || {}
        },

        updateDynamicProviderKey(state, dynamicProviderKey) {
            state.data = { ...state.data, dynamicProviderKey }
        },

        updateNextProviderKeyAfterExistingAccount(state, nextProviderKeyAfterExistingAccount) {
            state.data = { ...state.data, nextProviderKeyAfterExistingAccount }
        },
    },
}
